import { render, staticRenderFns } from "./ServerTypeServicesAdditionDialog.vue?vue&type=template&id=d953a8da&"
import script from "./ServerTypeServicesAdditionDialog.vue?vue&type=script&lang=ts&"
export * from "./ServerTypeServicesAdditionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports